import ReportsScreenConnector from './ReportsScreenConnector';

export default ReportsScreenConnector;
